import ProjectPropertyLookup, {SourceType} from "./project-property-lookup"
import ProjectSession from "../project-session"
import projectViews_checkIsOldSystemView from "../../project-view/functions/check-is-old-system-view"
import ProjectViews from "../../project-view/project-views"
import {ViewTypeConfigs} from "../../../gd/const/views/view-type-config";
import {ViewType} from "../../../gd/const/views/view-type";
import {ProjectViewConfig} from "../../project-view/@types";

const debug = false
// const debug = "ProjectViewsLookup"

// this class builds project views with inheritance
export default class ProjectViewsLookup extends ProjectPropertyLookup {

    constructor(projectId:ID) {
        super(projectId)
    }

    get(): ProjectViewConfig[] {
        this.sourceType = SourceType.GENERIC

        let res: ProjectViewConfig[] | null = null

        debug && console.log(debug, 'get', this.project.name, this.project.settings)

        // 1. check if project has property and retrieve views
        if (!_.isNil(this.project.settings?.views)) {
            res = this.getProjectViews(this.project)
            this.sourceType = SourceType.CUSTOM

            const parent = this.findAllParents()[0]
            if (parent) {
                const parentProjectViews: ProjectViews = ProjectViews.initByProjectId(parent.id)

                // remove isInherited from view if parent project has no view it was inherited from
                _.map(res, (viewConfig: ProjectViewConfig) => {
                    if (!parentProjectViews.get(viewConfig.id!)) {
                        delete viewConfig.isInherited
                    }
                })
            }
        }

        // 2. if views not found yet check parents
        if (_.isNil(res)) {
            _.some(this.findAllParents(), project => {
                // Inherited from parent
                const parentProjectViews: ProjectViews = ProjectViews.initByProjectId(project.id)
                res = parentProjectViews.exportJsonInheritance()

                //inherit only first view of each systemType
                const systemTypesInheritedMap: { [key in ViewType]?: boolean } = {}
                _.remove(res!, (viewConfig: ProjectViewConfig)=>{
                    if (!systemTypesInheritedMap[viewConfig.systemType]) {
                        systemTypesInheritedMap[viewConfig.systemType] = true
                        return false // do not remove
                    } else {
                        return true // remove
                    }
                })

                // if result found then inherited from current project
                if (res) {
                    this.sourceType         = SourceType.INHERITED
                    this.sourceProjectId    = project.id
                    return true // break iteration loop (_.some)
                }
            })
        }

        debug && console.log(debug, 'get res', res)

        return res || []
    }

    getProjectViews(project:ProjectSession): ProjectViewConfig[] | null {
        let viewsConfig: ProjectViewConfig[] | null = _.get(project, 'settings.views', null)


        /**--- Old views conversion [START] ---**/
        //check if it is old config (if it has any view with property isPinned set to true)
        // @ts-ignore
        const hasOldPinnedViews = _.some(viewsConfig, (viewConfig: ProjectViewConfig) => {
            return viewConfig.isPinned
        })

        if (hasOldPinnedViews) {
            const newViewsConfig: any[] = []

            _.map(viewsConfig, (viewConfig:any)=>{
                // special case for old system views
                if (projectViews_checkIsOldSystemView(viewConfig)) {
                    if (!viewConfig.isPinned) return        // skip all system views that are not pinned
                    viewConfig.systemType = viewConfig.id   // set systemType for system views
                }

                // add old system views that were pinned and all custom views
                newViewsConfig.push(viewConfig)
            })

            viewsConfig = newViewsConfig
        }

        // systemType should be number (one of ViewType) to work correctly in switch and compares with ViewType
        _.map(viewsConfig, (viewConfig:any)=>{
            if (typeof viewConfig.systemType === 'string') {
                viewConfig.systemType = parseInt(viewConfig.systemType)
            }
        })

        /**--- Old views conversion [END] ---**/

        //skip views that are not represented in ViewTypeConfigs
        viewsConfig = _.filter(viewsConfig, viewConfig=>!!ViewTypeConfigs[viewConfig.systemType as ViewType])

        return viewsConfig ? viewsConfig : null
    }
}